import { Utils } from 'cc-common';
import { Type } from 'class-transformer';
import { UserNameDisplayResultDto } from '../../_models/user-name-display-result-dto';

export class ProjectTaskItemResultDto {
    taskId: number;
    description: string;

    @Type(() => UserNameDisplayResultDto)
    enteredBy: UserNameDisplayResultDto;

    @Type(() => Date)
    enteredOn: Date;

    @Type(() => UserNameDisplayResultDto)
    responsible: UserNameDisplayResultDto;

    @Type(() => Date)
    dueDate: Date;

    item: string;
    status: string;

    @Type(() => Date)
    statusChangedOn: Date;

    @Type(() => UserNameDisplayResultDto)
    statusChangedBy: UserNameDisplayResultDto;

    communityId: number;

    @Type(() => Date)
    lastModified: Date;

    attachmentsCount: number;
    hasNote: boolean;
    workOrderIds: number[];

    @Type(() => UserNameDisplayResultDto)
    dashboardResponsible: UserNameDisplayResultDto;

    problematic: boolean;
    priority: boolean;
    location: string;
    managementCompany: string;
    community: string;
    allowEdit: boolean;
    allowChangeStatus: boolean;
    allowManageWorkOrders: boolean;
    allowCreateCase: boolean;
    emailCount: number;
    linkedInternalTaskCount: number;
    allowEmails: boolean;
    allowCreateWorkOrder: boolean;
    allowEditWorkOrder: boolean;

    get enteredByDisplayText(): string {
        return Utils.notNullAndDefined(this.enteredBy) ? this.enteredBy.displayName : '';
    }

    get responsibleDisplayText(): string {
        return Utils.notNullAndDefined(this.responsible) ? this.responsible.displayName : '';
    }

    get statusChangedByDisplayText(): string {
        return Utils.notNullAndDefined(this.statusChangedBy) ? this.statusChangedBy.displayName : '';
    }

    get dashboardResponsibleDisplayText(): string {
        return Utils.notNullAndDefined(this.dashboardResponsible) ? this.dashboardResponsible.displayName : '';
    }

    get dashboardStatusDisplayText(): string {
        let displayText = null;
        if (Utils.isTrue(this.problematic)) {
            displayText = 'Problematic';
        } else if (Utils.isTrue(this.priority)) {
            displayText = 'Priority';
        }
        return displayText;
    }

    get workOrderIdsDisplayText(): string {
        return Utils.notNullOrEmpty(this.workOrderIds) ? this.workOrderIds.join(',') : null;
    }
}
